import { render, staticRenderFns } from "./SelectorCertificado.vue?vue&type=template&id=04f8ca3a"
import script from "./SelectorCertificado.vue?vue&type=script&lang=js"
export * from "./SelectorCertificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports